var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import { artOptionSingleCls, artOptionSingleLabelCls, artOptionSinglePriceCls, artOptionSingleBtnCls } from "./Single.less";
var ArtOptionSingle = /* @__PURE__ */ __name(function ArtOptionSingle2(_ref) {
  var actionLabel = _ref.actionLabel, title = _ref.title, price = _ref.price, hint = _ref.hint, link = _ref.link;
  return /* @__PURE__ */ React.createElement("div", {
    className: artOptionSingleCls
  }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", {
    className: artOptionSingleLabelCls
  }, actionLabel, " ", title), hint), /* @__PURE__ */ React.createElement("span", {
    className: artOptionSinglePriceCls
  }, price), /* @__PURE__ */ React.createElement("span", {
    className: artOptionSingleBtnCls
  }, link));
}, "ArtOptionSingle");
export {
  ArtOptionSingle
};
